import { Link, createFileRoute } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { PageHeader } from '@/components/PageHeader';
import { UserList } from '@/components/community/UserRow';
import { useFollowers } from '@/lib/queries/users';

export const Route = createFileRoute('/_app/community/u/$handle/followers')({
  component: FollowersPage,
});

/** Quién sigue a esa cuenta, con el botón de seguir en cada fila. */
function FollowersPage() {
  const { handle } = Route.useParams();
  const query = useFollowers(handle);
  const users = query.data?.pages.flatMap((page) => page.items) ?? [];

  return (
    <>
      <PageHeader
        title="Seguidores"
        subtitle={`@${handle}`}
        action={
          <Link
            to="/community/u/$handle"
            params={{ handle }}
            search={{}}
            aria-label="Volver al perfil"
            className="flex size-11 items-center justify-center rounded-xl border border-line text-ink-muted transition-colors hover:bg-surface-raised active:bg-surface-raised"
          >
            <ArrowLeft className="size-5" aria-hidden="true" />
          </Link>
        }
      />

      <UserList
        users={users}
        isPending={query.isPending}
        isError={query.isError}
        error={query.error}
        onRetry={() => void query.refetch()}
        hasNextPage={query.hasNextPage}
        isFetchingNextPage={query.isFetchingNextPage}
        onLoadMore={() => void query.fetchNextPage()}
        errorTitle="No hemos podido cargar los seguidores"
        empty={
          <p className="rounded-2xl border border-dashed border-line bg-surface-raised px-5 py-10 text-center text-sm text-ink-muted">
            Todavía no sigue nadie a esta cuenta.
          </p>
        }
      />
    </>
  );
}
